import { useSelector } from "react-redux";

const builderSlice = (state: any) => state.builder;
const useSelector_project = () => useSelector((state: any) => builderSlice(state).project)
const useSelector_productContent = () => useSelector((state: any) => builderSlice(state).productContent)
const useSelector_designContent = () => useSelector((state: any) => builderSlice(state).designContent)
const useSelector_undoStackPointer = () => useSelector((state: any) => builderSlice(state).undoStackPointer)
const useSelector_undoStack = () => useSelector((state: any) => builderSlice(state).undoStack)
const useSelector_ui = () => useSelector((state: any) => builderSlice(state).ui)
const useSelector_activeSelection = () => useSelector((state: any) => builderSlice(state).activeSelection)
const useSelector_roomModels = () => useSelector((state: any) => builderSlice(state).roomModels)
const useSelector_roomAssets = () => useSelector((state: any) => builderSlice(state).roomAssets)
const useSelector_roomTypes = () => useSelector((state: any) => builderSlice(state).roomTypes)
const useSelector_ResourceLoadStatus = () => useSelector((state: any) => builderSlice(state).resourceLoadStatus)
const useSelector_TwoDRoomLayout = () => useSelector((state: any) => builderSlice(state).twoDRoomLayout)
const useSelector_TwoDUi = () => useSelector((state: any) => builderSlice(state).twoDUi)
const useSelector_TwoDUi_showSelectWallTooltip = () => useSelector((state: any) => builderSlice(state).twoDUi.showSelectWallTooltip)
const useSelector_TwoDUi_showLayoutInfoTooltip = () => useSelector((state: any) => builderSlice(state).twoDUi.showLayoutInfoTooltip)
const useSelector_generate_preview=()=>useSelector((state:any)=>builderSlice(state).generatePreview)
const useSelector_ui_exposure = () => useSelector((state: any) => builderSlice(state).ui.exposure)
const useSelector_products_sku_id_list = () => useSelector((state: any) => builderSlice(state).ui.products_sku_id_list)
const useSelector_template = () => useSelector((state: any) => builderSlice(state).template)

const BuilderSelct = {
    project: useSelector_project,
    productContent: useSelector_productContent,
    designContent: useSelector_designContent,
    undoStackPointer: useSelector_undoStackPointer,
    undoStack: useSelector_undoStack,
    ui: useSelector_ui,
    activeSelection: useSelector_activeSelection,
    roomModels: useSelector_roomModels,
    roomAssets: useSelector_roomAssets,
    roomTypes: useSelector_roomTypes,
    resourceLoadStatus: useSelector_ResourceLoadStatus,
    twoDRoomLayout: useSelector_TwoDRoomLayout,
    twoDUi: useSelector_TwoDUi,
    twoDUi_showSelectWallTooltip: useSelector_TwoDUi_showSelectWallTooltip,
    twoDUi_showLayoutInfoTooltip: useSelector_TwoDUi_showLayoutInfoTooltip,
    generatePreview:useSelector_generate_preview,
    ui_exposure: useSelector_ui_exposure,
    products_sku_id_list: useSelector_products_sku_id_list,
    template:useSelector_template
}
export default BuilderSelct;